import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { PreferencesEffects } from './state/effects/preferences.effects';
import * as fromUsers from './state/reducers';

@NgModule({
  imports: [StoreModule.forFeature(fromUsers.userPreferencesFeatureKey, fromUsers.userPreferencesReducers), EffectsModule.forFeature([PreferencesEffects])]
})
export class PreferencesModule {}
